module.exports = __webpack_public_path__ + "static/media/fuvi.ab520f8d.svg";